import Breadcrumb from "@/components/feature/Breadcrumb";
import CatalogView from "@/components/feature/CatalogView";
import { useDocumentMeta } from "@/hooks/useDocumentMeta";
import { tvshows } from "@/lib/content";

export default function TvShows() {
  useDocumentMeta({
    title: "电视剧 - 夜无疆影视大全",
    description:
      "热门电视剧全集介绍，夜无疆为你整理悬疑、古装、都市、科幻、喜剧等剧集资源与追剧指南，支持多维筛选。",
    keywords: "电视剧,热门电视剧,电视剧全集,悬疑剧,古装剧,都市剧,夜无疆电视剧",
  });

  return (
    <div className="w-full animate-fadeIn">
      <div className="border-b border-background-200/70 bg-background-100/40 px-4 py-8 md:px-6 lg:px-10 lg:py-10">
        <Breadcrumb items={[{ label: "首页", href: "/" }, { label: "电视剧" }]} />
        <h1 className="mt-4 font-heading text-2xl font-extrabold text-foreground-950 md:text-4xl">电视剧</h1>
        <p className="mt-3 max-w-3xl text-sm leading-7 text-foreground-600 md:text-base">
          收录正在更新的热播剧与口碑佳作，涵盖悬疑、犯罪、古装、都市、喜剧与科幻等题材。每部剧集都标注集数与更新状态，方便你按类型、地区与年份快速定位想追的剧。
        </p>
      </div>

      <div className="w-full px-4 py-8 md:px-6 lg:px-10 lg:py-10">
        <CatalogView items={tvshows} emptyText="暂无符合筛选条件的电视剧" />
      </div>
    </div>
  );
}